// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"archive-articles_wrapper__szcFc","result":"archive-articles_result__zHlMM"};